import * as yup from 'yup';

export type LoginModel = {
    email: string;
    password: string;
    rememberMe: boolean;
    errors?: boolean;
}

export const loginSchema: yup.ObjectSchema<LoginModel> = yup.object().shape({
    email: yup.string().required().email(),
    password: yup.string().required(),
    rememberMe: yup.boolean().required(),
    errors: yup.boolean()
});